export namespace WecomaConstants {
    export const COOKIE_EXPIRATION = 365;
    export const ALL_RECHECK_EXPIRATION = 30;
    export const SOME_RECHECK_EXPIRATION = 60;

    export const COOKIE_NAME = "cbada";
    export const CONSENT_CACHE_COOKIE_NAME = "consents";
    export const WECOMA_AUTHKEY = "device";

    const WECOMA_CODE_DEH = "da";
    // Kasa wecoma portal is in reality DEH wecoma portal
    const WECOMA_CODE_KASA = "sa";
    export const WECOMA_CODE = environment.isKasa ? WECOMA_CODE_KASA : WECOMA_CODE_DEH;
}
